/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type TopOffersContainer_lists$ref = any;
export type TopOffersContainerQueryVariables = {||};
export type TopOffersContainerQueryResponse = {|
  +lists: ?{|
    +$fragmentRefs: TopOffersContainer_lists$ref
  |}
|};
export type TopOffersContainerQuery = {|
  variables: TopOffersContainerQueryVariables,
  response: TopOffersContainerQueryResponse,
|};
*/


/*
query TopOffersContainerQuery {
  lists {
    ...TopOffersContainer_lists
    id
  }
}

fragment TopOfferCell_offer on Offer {
  id
  title
  startDate
  endDate
  store {
    name
    id
  }
}

fragment TopOffersContainer_lists on Lists {
  topOffers(first: 50) {
    edges {
      node {
        id
        ...TopOfferCell_offer
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TopOffersContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TopOffersContainer_lists"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TopOffersContainerQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Lists",
        "kind": "LinkedField",
        "name": "lists",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 50
              }
            ],
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "topOffers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Offer",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endDate",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Store",
                        "kind": "LinkedField",
                        "name": "store",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "name",
                            "storageKey": null
                          },
                          (v0/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "topOffers(first:50)"
          },
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TopOffersContainerQuery",
    "operationKind": "query",
    "text": "query TopOffersContainerQuery {\n  lists {\n    ...TopOffersContainer_lists\n    id\n  }\n}\n\nfragment TopOfferCell_offer on Offer {\n  id\n  title\n  startDate\n  endDate\n  store {\n    name\n    id\n  }\n}\n\nfragment TopOffersContainer_lists on Lists {\n  topOffers(first: 50) {\n    edges {\n      node {\n        id\n        ...TopOfferCell_offer\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '78f4717089596658aecbb19fc9cab6e9';

module.exports = node;
